import React from 'react';
import { Button } from '@mui/material';
import { useHubStyles } from '../../hooks/useHubStyles';
import { HUB_TYPES } from '../../utils/hubRoutes';
import {
    getHubDialogCancelButtonSx,
    getHubDialogSubmitButtonSx,
} from '../../theme/hubThemes';

export function HubDialogCancelButton({
    children,
    hubType = HUB_TYPES.PROJECT_MANAGEMENT,
    sx,
    ...props
}) {
    const styles = useHubStyles(hubType);
    return (
        <Button sx={{ ...getHubDialogCancelButtonSx(styles), ...sx }} {...props}>
            {children}
        </Button>
    );
}

export function HubDialogSubmitButton({
    children,
    hubType = HUB_TYPES.PROJECT_MANAGEMENT,
    sx,
    color,
    variant = 'contained',
    ...props
}) {
    const styles = useHubStyles(hubType);
    const useHubSubmitSx = variant === 'contained' && !color;
    return (
        <Button
            variant={variant}
            disableElevation={variant === 'contained'}
            color={color || 'primary'}
            sx={useHubSubmitSx ? { ...getHubDialogSubmitButtonSx(styles), ...sx } : sx}
            {...props}
        >
            {children}
        </Button>
    );
}
